import { trackEvent } from 'core-lib/utils/events';
import { getCommonEventAttr } from './index';

export const trackVariantClicked = () => {
  trackEvent({
    name: 'car_listing_variant_clicked',
    defaultAttr: getCommonEventAttr(),
  });
};

export const trackDetailedSpecSearch = () => {
  trackEvent({
    name: 'car_listing_variant_spec_search',
    defaultAttr: getCommonEventAttr(),
  });
};

export const trackOnRoadPriceClicked = () => {
  trackEvent({
    name: 'car_listing_variant_road_price',
    defaultAttr: getCommonEventAttr(),
  });
};

export const trackDetailedSpecClicked = (specKey) => {
  trackEvent({
    name: 'car_listing_variant_spec',
    defaultAttr: { ...getCommonEventAttr(), specKey },
  });
};
